import { render, staticRenderFns } from "./MainCategory.vue?vue&type=template&id=75ac0410&"
import script from "./MainCategory.vue?vue&type=script&lang=js&"
export * from "./MainCategory.vue?vue&type=script&lang=js&"
import style0 from "./MainCategory.vue?vue&type=style&index=0&id=75ac0410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports